var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "plans__container" },
    [
      _c("Card", _vm._b({}, "Card", _vm.options, false), [
        _c(
          "div",
          { staticClass: "period__switch" },
          [
            _c("PeriodToggle", {
              attrs: {
                type: "text",
                label: { before: "Month", after: "Year" },
                id: "textype"
              },
              model: {
                value: _vm.period,
                callback: function($$v) {
                  _vm.period = $$v
                },
                expression: "period"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "title__container" }, [
          _c("span", [_vm._v(_vm._s(_vm.data.title))]),
          _vm._v(" "),
          _c("p", { domProps: { innerHTML: _vm._s(_vm.data.description) } })
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "packs__list" },
          [
            _vm._l(_vm.data.packs, function(pack, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "pack",
                  style: pack.packName == "premium" ? " height : 30rem;" : null
                },
                [
                  _c(
                    "PlanCard",
                    _vm._b(
                      {
                        on: {
                          handleclick: function($event) {
                            return _vm.choosePack(
                              Object.assign({}, pack, { period: _vm.period })
                            )
                          }
                        }
                      },
                      "PlanCard",
                      Object.assign({}, pack, { period: _vm.period }),
                      false
                    )
                  )
                ],
                1
              )
            }),
            _vm._v(" "),
            _c("div", { staticClass: "credit__cards" }, [
              _c("span", [_vm._v("+ More")])
            ])
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "title__container" }, [
        _c("span", [_vm._v(_vm._s(_vm.data.compare_table.title))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "table__container" }, [
        _c("table", [
          _c("thead", [
            _c(
              "tr",
              _vm._l(_vm.data.compare_table.columns, function(col, index) {
                return _c(
                  "th",
                  {
                    key: index,
                    style: "background-color:" + col.color,
                    attrs: { width: col.width }
                  },
                  [
                    _c("span", { staticClass: "col__name" }, [
                      _vm._v(_vm._s(col.name) + " ")
                    ])
                  ]
                )
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            [
              _vm._l(_vm.data.compare_table.elements, function(
                item,
                itemIndex
              ) {
                return _c(
                  "tr",
                  {
                    key: itemIndex,
                    staticClass: "tbody",
                    style:
                      itemIndex % 2 == 0
                        ? "background-color:#fff"
                        : "background-color:#F2F2F2;"
                  },
                  _vm._l(_vm.data.compare_table.columns, function(
                    col,
                    colIndex
                  ) {
                    return _c(
                      "td",
                      {
                        key: colIndex,
                        style: {
                          backgroundColor:
                            col.key == "premium"
                              ? itemIndex % 2 == 0
                                ? "#6D49A2"
                                : "#6d49a273"
                              : null,
                          color:
                            item.colors && item.colors[col.key]
                              ? item.colors[col.key]
                              : null
                        }
                      },
                      [
                        _c("div", [
                          item["currency"] && col.key != "property"
                            ? _c("sup", [_vm._v(_vm._s(item["currency"]))])
                            : _vm._e(),
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                item[col.key] &&
                                  typeof item[col.key] != "boolean"
                                  ? item[col.key]
                                  : ""
                              ) +
                              "\n                                "
                          ),
                          item["period"] && col.key != "property"
                            ? _c("span", [_vm._v("/" + _vm._s(_vm.period))])
                            : _vm._e(),
                          _vm._v(" "),
                          item[col.key] && typeof item[col.key] == "boolean"
                            ? _c("span", { staticClass: "check_icon" }, [
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      xmlns: "http://www.w3.org/2000/svg",
                                      fill: "#51D879",
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                      version: "1.1",
                                      width: "24",
                                      height: "24",
                                      viewBox: "0 0 24 24"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d:
                                          "M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
                                      }
                                    })
                                  ]
                                )
                              ])
                            : _vm._e()
                        ])
                      ]
                    )
                  }),
                  0
                )
              }),
              _vm._v(" "),
              _c(
                "tr",
                _vm._l([null, "basic", "pro", "premium"], function(actionName) {
                  return _c(
                    "td",
                    { key: actionName, staticClass: "tab__action" },
                    [
                      _c(
                        "div",
                        [
                          actionName
                            ? _c(
                                "Button",
                                _vm._b(
                                  {},
                                  "Button",
                                  Object.assign(
                                    _vm.data.compare_table.actions[actionName],
                                    actionName == "premium"
                                      ? _vm.premiumBtnStyle
                                      : {}
                                  ),
                                  false
                                )
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                }),
                0
              )
            ],
            2
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7fb7a198", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fb7a198","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user_profile/company/plans.vue
// module id = null
// module chunks = 